import { render, staticRenderFns } from "./PrecisionAccuracy.vue?vue&type=template&id=3658b528&scoped=true"
import script from "./PrecisionAccuracy.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrecisionAccuracy.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PrecisionAccuracy.vue?vue&type=style&index=0&id=3658b528&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3658b528",
  null
  
)

export default component.exports